var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeatherBracelet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 40C96.5 42.3243 94.6302 44.6475 90.9951 46.765C87.3911 48.8644 82.198 50.6706 75.8962 52.0087C72.2482 52.7832 68.2135 52.6649 63.8497 52.3431C62.7815 52.2643 61.6933 52.1733 60.5876 52.0808C57.1975 51.7973 53.6432 51.5 50 51.5C46.3568 51.5 42.8025 51.7973 39.4124 52.0808C38.3067 52.1733 37.2185 52.2643 36.1503 52.3431C31.7865 52.6649 27.7518 52.7832 24.1038 52.0087C17.802 50.6706 12.6089 48.8644 9.00486 46.765C5.3698 44.6475 3.5 42.3243 3.5 40C3.5 38.1573 4.67054 36.3141 6.99465 34.5604C9.31046 32.8131 12.6931 31.2181 16.918 29.8697C25.362 27.1748 37.0583 25.5 50 25.5C62.9417 25.5 74.638 27.1748 83.082 29.8697C87.3069 31.2181 90.6895 32.8131 93.0053 34.5604C95.3295 36.3141 96.5 38.1573 96.5 40Z",
    stroke: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4999 44C94.6721 48.3783 87.0124 52.1595 75.9999 54.4977C68.5537 56.0787 59.6139 54 49.9999 54C40.3859 54 31.4461 56.0787 23.9999 54.4977C12.9874 52.1595 5.32783 48.8783 3.5 44.5",
    stroke: "#039BE5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 50.3192C74.5138 47.6484 62.8601 46 50 46C37.1399 46 25.4862 47.6484 17 50.3192",
    stroke: "#039BE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 40V62C96.5 66.3891 92.4236 69.0432 80 72C72.6099 73.7588 65 77.5 50 77.5C35 77.5 27.3901 73.7588 20 72C7.57641 69.0432 3.5 66.3891 3.5 62V40",
    stroke: "#039BE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 60C96.5 64.3891 92.4236 67.0432 80 70C72.6099 71.7588 65 75.5 50 75.5C35 75.5 27.3901 71.7588 20 70C7.57641 67.0432 3.5 64.3891 3.5 60",
    stroke: "#039BE5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 36,
    r: 4.5,
    stroke: "#039BE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 37,
    r: 2.5,
    stroke: "#039BE5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 2.5,
    stroke: "#039BE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 26L42.5 25.5H42.5V26ZM54.5 29L54.4547 29.4979L54.5 29ZM61 36.5C61 36.7761 61.2239 37 61.5 37C61.7761 37 62 36.7761 62 36.5H61ZM38.5 25.5C38.2239 25.5 38 25.7239 38 26C38 26.2761 38.2239 26.5 38.5 26.5V25.5ZM42.5 26.5C43.887 26.5 45.2013 27.0584 47.083 27.7537C48.9372 28.4388 51.234 29.2052 54.4547 29.4979L54.5453 28.5021C51.4495 28.2206 49.2463 27.487 47.4296 26.8157C45.6404 26.1545 44.113 25.5 42.5 25.5L42.5 26.5ZM54.4547 29.4979C56.4797 29.682 58.1027 30.2814 59.2185 31.3747C60.3256 32.4595 61 34.0964 61 36.5H62C62 33.9036 61.2656 31.9806 59.9184 30.6605C58.5798 29.3488 56.7028 28.6982 54.5453 28.5021L54.4547 29.4979ZM42.5 25.5H38.5V26.5H42.5V25.5Z",
    fill: "#039BE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5266 46.1345L42.4854 45.6362L42.506 45.6345L42.5266 45.6345L42.5266 46.1345ZM54.5 43.5L54.4547 43.002L54.5 43.5ZM61 36C61 35.7238 61.2239 35.5 61.5 35.5C61.7761 35.5 62 35.7238 62 36H61ZM38.5575 46.9639C38.2823 46.9866 38.0408 46.7819 38.0181 46.5067C37.9953 46.2315 38.2 45.99 38.4752 45.9673L38.5575 46.9639ZM42.5266 45.6345C43.9285 45.6345 45.2511 45.1552 47.1168 44.5565C48.9614 43.9645 51.2443 43.2939 54.4547 43.002L54.5453 43.9979C51.4392 44.2803 49.2354 44.9269 47.4224 45.5086C45.6305 46.0836 44.1246 46.6345 42.5266 46.6345L42.5266 45.6345ZM54.4547 43.002C56.4797 42.8179 58.1027 42.2186 59.2185 41.1252C60.3256 40.0404 61 38.4036 61 36H62C62 38.5964 61.2656 40.5194 59.9184 41.8395C58.5798 43.1511 56.7028 43.8018 54.5453 43.9979L54.4547 43.002ZM42.5677 46.6328L38.5575 46.9639L38.4752 45.9673L42.4854 45.6362L42.5677 46.6328Z",
    fill: "#039BE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 42C5.5 38 9 34.5001 20 31C33.5 28 37.5 27.5001 43 28.0001C47.5 29.0001 46.5 29.5 50 30C53 30 56.7031 30.2031 58 31.5C59.5 33 60 34 60 36C60 38 60 40.5 57 41.5C54 42.5 48.5 43 48.5 43C48.5 43 46 44.0001 41 44.5001C36.5 44.5001 19 47 15 49.5",
    stroke: "#039BE5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49 44.5C56.5 44.1666 74.1 44.7 84.5 49.5",
    stroke: "#039BE5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47 27.0801C54.5 26.7468 87.5 28 96.5 40.5",
    stroke: "#039BE5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeatherBracelet);
export default ForwardRef;